import PackageJson from "../../package.json";

export const getAppVersion = () => PackageJson.version;
